module.exports = __webpack_public_path__ + "assets/img/video-play.9c1e4ebe.svg";